import { ID } from '@griply/types';
import { getUpcomingCustomOrder } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useUpcomingListCustomOrder = (): Record<ID, ID[]> => {
  const user = useUser();

  return useMemo(
    () => getUpcomingCustomOrder(user?.settings),
    [user?.settings],
  );
};
